export const AdminTitle = ({ title, children, action }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
    <div>
      <h1 className="font-display text-3xl sm:text-4xl">{title}</h1>
      {children && <p className="text-sm text-[#F8F6F1]/55 mt-2">{children}</p>}
    </div>
    {action}
  </div>
);

export const AdminField = ({ label, className = "", textarea, testid, ...props }) => {
  const cls = "mt-1.5 w-full bg-[#0B0B0B] border border-[#C9A45C]/25 px-3 py-2.5 text-sm outline-none focus:border-[#C9A45C]";
  return (
    <label className={`block ${className}`}>
      <span className="text-[10px] tracking-[0.2em] uppercase text-[#F8F6F1]/50">{label}</span>
      {textarea ? <textarea {...props} className={cls} data-testid={testid} /> : <input {...props} className={cls} data-testid={testid} />}
    </label>
  );
};

export const AdminCheck = ({ label, checked, onChange, testid }) => (
  <label className="flex items-center gap-2 text-sm cursor-pointer">
    <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="accent-[#C9A45C] h-4 w-4" data-testid={testid} />
    {label}
  </label>
);

export const Panel = ({ children, className = "", ...rest }) => (
  <div className={`border border-[#C9A45C]/15 bg-[#101010] ${className}`} {...rest}>{children}</div>
);
